export const mockData = {
  en: {
    nav: {
      home: 'Home',
      products: 'Products',
      capabilities: 'Capabilities',
      sustainability: 'Sustainability',
      references: 'References',
      blog: 'Blog',
      about: 'About',
      contact: 'Contact'
    },
    hero: {
      titleLine1: 'Fast, Flexible Label &',
      titleLine2: 'Packaging Production',
      titleHighlight: 'for Europe',
      subtitle: 'Reliable production with short lead times, flexible quantities and certified materials.',
      ctaQuote: 'Get a Quote',
      ctaSamples: 'Request Samples',
      certifications1: 'OEKO-TEX®, FSC® and GRS certified materials.',
      certifications2: 'SEDEX audited, PETA-Approved Vegan production.',
      scrollText: 'Scroll to explore'
    },
    intro: {
      text: 'Since 1983, with over 40 years of experience, we have successfully positioned ourselves as one of the most comprehensive label manufacturers on both national and international levels.',
      highlight: 'As Etiteks, providing all labeling and packaging solutions together, we export products to more than 60 countries with our four different production facilities located in Istanbul.'
    },
    offer: {
      title: 'Our offer',
      subtitle: 'With our six pillars, we create a holistic offer with optimal solutions to assist our customers and their brands in their development.',
      pillars: [
        { title: 'Sustainability', icon: '🌱' },
        { title: 'Design', icon: '✏️' },
        { title: 'Product Development', icon: '🔧' },
        { title: 'Production', icon: '⚙️' },
        { title: 'Logistics', icon: '🚚' },
        { title: 'Certified Quality', icon: '🏆' }
      ]
    },
    products: {
      title: 'Products',
      items: [
        {
          title: 'Labels',
          description: 'Woven, printed and heat transfer labels',
          image: 'https://customer-assets.emergentagent.com/job_branding-hub-2/artifacts/yt5f1ens_img-dokuma-etiket%20%281%29.jpg'
        },
        {
          title: 'Hang Tags',
          description: 'Custom hang tags that showcase your brand story and values',
          image: 'https://customer-assets.emergentagent.com/job_2626b563-ef30-408d-8380-25533662d40f/artifacts/a6pbakjk_karton-etiket-6.jpg'
        },
        {
          title: 'Patches',
          description: 'Embroidery, leather and silicone patches',
          image: 'https://customer-assets.emergentagent.com/job_branding-hub-2/artifacts/89c4p0gz_tashansdasdasd.jpg'
        },
        {
          title: 'Packaging',
          description: 'Premium packaging solutions that elevate your brand',
          image: 'https://customer-assets.emergentagent.com/job_etiteks-textile/artifacts/cb1fhqlb_karton-kutu-3.jpg'
        }
      ]
    },
    about: {
      title: 'All Labeling and Packaging Solutions in One Place',
      description: 'With over 40 years of experience since 1983, we have successfully positioned ourselves as one of the most comprehensive label manufacturers nationally and internationally.',
      fullText: 'As Etiteks, offering all labeling and packaging solutions together, we export products to more than 60 countries with our four different production facilities located in Istanbul.',
      vision: {
        title: 'Our Vision and Values',
        text: 'Our vision is to strive for excellence by delivering high-quality products, meeting our customers\' demands with the right timing and accessible costs. As a company that respects the environment and human rights, we aim to be a leader in the industry, continuously evolving, and always developing new techniques for the creation of an innovative and sustainable textile ecosystem.'
      }
    },
    stats: {
      items: [
        { number: '43+', label: 'years experience', sublabel: 'Industry know-how' },
        { number: '30+', label: 'countries served', sublabel: 'Europe-focused supply' },
        { number: '40M+', label: 'pieces monthly', sublabel: 'Scalable production capacity' },
        { number: '2-3', label: 'days delivery to Europe', sublabel: 'Fast delivery after production' }
      ]
    },
    footer: {
      description: 'Label & packaging manufacturer based in Istanbul',
      address: 'Istanbul, Turkey',
      email: 'info@etiteks.com',
      phone: '+90 212 501 42 57',
      copyright: '© 2024 Etiteks. All rights reserved.'
    }
  },
  tr: {
    nav: {
      home: 'Ana Sayfa',
      products: 'Ürünler',
      capabilities: 'Yetenekler',
      sustainability: 'Sürdürülebilirlik',
      references: 'Referanslar',
      blog: 'Blog',
      about: 'Hakkımızda',
      contact: 'İletişim'
    },
    hero: {
      titleLine1: 'Hızlı, Esnek Etiket &',
      titleLine2: 'Ambalaj Üretimi',
      titleHighlight: 'Avrupa için',
      subtitle: 'Kısa teslim süreleri, esnek miktarlar ve sertifikalı malzemelerle güvenilir üretim.',
      ctaQuote: 'Teklif Alın',
      ctaSamples: 'Numune Talep Edin',
      certifications1: 'OEKO-TEX®, FSC® ve GRS sertifikalı malzemeler.',
      certifications2: 'SEDEX denetimli, PETA Onaylı Vegan üretim.',
      scrollText: 'Keşfetmek için kaydırın'
    },
    intro: {
      text: '1983 yılından bu yana 40 yılı aşkın deneyimimizle, ulusal ve uluslararası alanda en kapsamlı etiket üreticilerinden biri olarak başarılı bir şekilde konumlandık.',
      highlight: 'Etiteks olarak tüm etiketleme ve ambalaj çözümlerini bir arada sunarak, İstanbul\'da bulunan dört farklı üretim tesisimizle 60\'tan fazla ülkeye ürün ihraç ediyoruz.'
    },
    offer: {
      title: 'Teklifimiz',
      subtitle: 'Altı temel sütunumuzla, müşterilerimize ve markalarına gelişimlerinde yardımcı olmak için optimal çözümlerle bütünsel bir teklif oluşturuyoruz.',
      pillars: [
        { title: 'Sürdürülebilirlik', icon: '🌱' },
        { title: 'Tasarım', icon: '✏️' },
        { title: 'Ürün Geliştirme', icon: '🔧' },
        { title: 'Üretim', icon: '⚙️' },
        { title: 'Lojistik', icon: '🚚' },
        { title: 'Sertifikalı Kalite', icon: '🏆' }
      ]
    },
    products: {
      title: 'Ürünler',
      items: [
        {
          title: 'Etiketler',
          description: 'Dokuma, baskılı ve ısı transfer etiketleri',
          image: 'https://customer-assets.emergentagent.com/job_branding-hub-2/artifacts/yt5f1ens_img-dokuma-etiket%20%281%29.jpg'
        },
        {
          title: 'Karton Etiketler',
          description: 'Marka hikayenizi ve değerlerinizi sergileyen özel karton etiketler',
          image: 'https://customer-assets.emergentagent.com/job_2626b563-ef30-408d-8380-25533662d40f/artifacts/a6pbakjk_karton-etiket-6.jpg'
        },
        {
          title: 'Yamalar',
          description: 'Nakış, deri ve silikon yamalar',
          image: 'https://customer-assets.emergentagent.com/job_branding-hub-2/artifacts/89c4p0gz_tashansdasdasd.jpg'
        },
        {
          title: 'Ambalaj',
          description: 'Markanızı yükselten premium ambalaj çözümleri',
          image: 'https://customer-assets.emergentagent.com/job_etiteks-textile/artifacts/cb1fhqlb_karton-kutu-3.jpg'
        }
      ]
    },
    about: {
      title: 'Tüm Etiket ve Ambalaj Çözümleri Tek Çatı Altında',
      description: '1983 yılından bu yana 40 yılı aşkın deneyimimizle, ulusal ve uluslararası alanda en kapsamlı etiket üreticilerinden biri olarak başarılı bir şekilde konumlandık.',
      fullText: 'Etiteks olarak tüm etiketleme ve ambalaj çözümlerini bir arada sunarak, İstanbul\'da bulunan dört farklı üretim tesisimizle 60\'tan fazla ülkeye ürün ihraç ediyoruz.',
      vision: {
        title: 'Vizyonumuz ve Değerlerimiz',
        text: 'Vizyonumuz, yüksek kaliteli ürünler sunarak, müşterilerimizin taleplerini doğru zamanlama ve erişilebilir maliyetlerle karşılayarak mükemmellik için çabalamaktır. Çevreye ve insan haklarına saygı duyan bir şirket olarak, sürekli gelişen ve yenilikçi ve sürdürülebilir bir tekstil ekosisteminin yaratılması için her zaman yeni teknikler geliştiren sektörde lider olmayı hedefliyoruz.'
      }
    },
    stats: {
      items: [
        { number: '43+', label: 'yıllık deneyim', sublabel: 'Sektör bilgi birikimi' },
        { number: '30+', label: 'ülkeye hizmet', sublabel: 'Avrupa odaklı tedarik' },
        { number: '40M+', label: 'aylık adet', sublabel: 'Ölçeklenebilir üretim kapasitesi' },
        { number: '2-3', label: 'gün Avrupa teslimatı', sublabel: 'Üretim sonrası hızlı teslimat' }
      ]
    },
    footer: {
      description: 'İstanbul merkezli etiket ve ambalaj üreticisi',
      address: 'İstanbul, Türkiye',
      email: 'info@etiteks.com',
      phone: '+90 212 501 42 57',
      copyright: '© 2024 Etiteks. Tüm hakları saklıdır.'
    }
  }
};